import React, { useState } from "react";
import axios from "axios";

const ContactUs = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");

    try {
      const res = await axios.post("/api/contact-us/", form);
      setStatus(res.data.message);
      setForm({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      console.error("Error sending message:", err);
      setStatus("Failed to send message. Please try again later.");
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-card">
        <h1>Help & Support</h1>
        <p>
          Please fill out the form below or reach us
          through the following details.
        </p>

<div className="company-info">
  <h3>Monconnect Services Pvt. Ltd.</h3>
  <p><strong>Email:</strong></p>
  <ul>
    <li>sahil@monconnect.com</li>
    <li>vishal@monconnect.com</li>
  </ul>
  <p><strong>Address:</strong> Vashi, Navi Mumbai</p>
</div>

        <form onSubmit={handleSubmit}>
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Your Name"
            required
          />
          <input
            type="email"
            name="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Your Email"
            required
          />
          <input
            type="text"
            name="subject"
            value={form.subject}
            onChange={handleChange}
            placeholder="Subject"
            required
          />
          <textarea
            name="message"
            value={form.message}
            onChange={handleChange}
            placeholder="Your Message"
            required
          ></textarea>

          <button type="submit">Send Message</button>
        </form>

        {status && <p className="status">{status}</p>}
      </div>

      <style>{`
        .contact-container {
          display: flex;
          justify-content: center;
          padding: 40px;
          background: #f9fafb;
          min-height: 80vh;
        }

        .contact-card {
          background: white;
          padding: 30px 40px;
          border-radius: 12px;
          box-shadow: 0 4px 10px rgba(0,0,0,0.1);
          max-width: 700px;
          width: 100%;
          font-family: Arial, sans-serif;
        }

        .card h1 {
          color: #102a71;
          text-align: center;
          margin-bottom: 20px;
        }

        .company-info {
          background: #f3f4f6;
          padding: 15px;
          border-radius: 8px;
          margin-bottom: 20px;
        }

        form {
          display: flex;
          flex-direction: column;
          gap: 15px;
        }

        input, textarea {
          padding: 10px;
          border: 1px solid #ccc;
          border-radius: 8px;
          font-size: 14px;
          width: 100%;
        }

        textarea {
          min-height: 120px;
          resize: vertical;
        }

        button {
          background-color: #102a71;
          color: white;
          border: none;
          padding: 10px 15px;
          border-radius: 8px;
          cursor: pointer;
          transition: 0.3s;
        }

        button:hover {
          background-color: #0b1f58;
        }

        .status {
          margin-top: 15px;
          text-align: center;
          font-weight: bold;
          color: #102a71;
        }
      `}</style>
    </div>
  );
};

export default ContactUs;
